// Which group of the rail you are in, and which page inside it.
//
// The rail shows a group's pages only while you are in that group, so being wrong about this does
// not merely mis-colour a row: it takes the other pages of the group off the screen. That is what
// happened on Outbound operations, which the rule for Today did not mention, so opening it closed
// the group it belongs to.
//
// Kept out of the component and tested, because the answer is a small piece of reasoning about
// paths and the component is where it was easy to get wrong.

// A destination can carry a query - Exceptions opens with its date range cleared - and it is the
// same page with or without it. Everything below compares routes, never query strings.
export const matchesPath = (pathname, path) => {
  const route = (path || '').split('?')[0];
  if (route === '/') return pathname === '/';
  const root = `/${route.split('/')[1]}`;
  return pathname === root || pathname.startsWith(`${root}/`);
};

// A group owns its own page, every page listed under it, and the few pages that have no entry of
// their own - an old address kept working, or a screen reached from somewhere else.
const ALSO = { configuration: ['/administration'] };

export const sectionActive = (pathname, section) => (
  matchesPath(pathname, section.path)
  || (section.children || []).some((child) => matchesPath(pathname, child.path))
  || (ALSO[section.key] || []).some((path) => matchesPath(pathname, path))
);
